import { useEffect, useCallback } from "react";

import { useLocalization } from "contexto/localization/useLocalization";


const useBackCheck = () => {
    const { strings } = useLocalization();
    const onBackButtonEvent = useCallback((e) => {
        e.preventDefault();
        if (!window.confirm(`${strings.modules.deseaSalirPagina}\n${strings.modules.alertaPerdidaCambios}`)) {
            window.history.pushState(null, null, window.location.pathname);
        } else {
            window.history.back();
        }
    }, [strings.modules.alertaPerdidaCambios, strings.modules.deseaSalirPagina]);

    useEffect(() => {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', onBackButtonEvent);
        return () => {
            window.removeEventListener('popstate', onBackButtonEvent);
        };
    }, [onBackButtonEvent]);

    return;
}

export default useBackCheck;